import { render, staticRenderFns } from "./CreateNFT.vue?vue&type=template&id=20eadb20&"
import script from "./CreateNFT.vue?vue&type=script&lang=js&"
export * from "./CreateNFT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports